export default __webpack_public_path__ + "04d108a60c046d8f1fa3d118a9e0ab80.png";